/**
 * Creates header dropdown menu items for equipment details
 * @param {boolean} isActive - Equipment active status
 * @param {Function} t - Translation function
 * @returns {Array} Menu items configuration
 */
export const createMoreMenuItems = (isActive, t) => [
  {
    key: "duplicate",
    label: t("global.duplicate")
  },
  {
    key: "deactivate",
    label: isActive ? t("global.deactivate") : t("global.activate")
  },
  {
    key: "delete",
    label: t("global.delete"),
    danger: true
  }
]

/**
 * Creates tab items for equipment details page
 * @param {Function} t - Translation function
 * @returns {Array} Tab items configuration
 */
export const createTabItems = (t) => [
  {
    key: "details",
    label: t("equipment.details.details_title")
  },
  {
    key: "calendar",
    label: "Calendar"
  }
]
